import parse from "html-react-parser";
import { useDispatch } from "react-redux";
import { Box, Img, Text, Flex, Skeleton } from "@chakra-ui/react";

import { removeFromCart } from "../../redux/actions";
import IsDoctor from "../permission/isDoctor";

import Quantity from "./quantity";
import Delete from "../../../src/assets/svg/delete";

export default function Index({ product }) {
  const dispatch = useDispatch();
  const { id, name, image, price, quantity, doctorPrice, shortDescription } =
    product;

  const productSubTotal =
    quantity * (IsDoctor() ? parseFloat(doctorPrice) : parseFloat(price));

  return (
    <Flex
      p="20px"
      bg="white"
      width="100%"
      height="150px"
      borderWidth="1px"
      borderTopWidth={0}
      borderColor="cartItemBorder"
    >
      <Box width="45%">
        <Flex>
          <Img
            lazy="true"
            width="110px"
            height="110px"
            src={image.src}
            objectFit="contain"
            alt="product-image"
            fallback={<Skeleton w="100%" h="100%" />}
          />
          <Box ml="5px">
            <Text variant="cartBold">{name}</Text>
            <Text noOfLines={3} variant="cartItemDescription">
              {parse(shortDescription)}
            </Text>
          </Box>
        </Flex>
      </Box>
      <Box width="12%">
        <Text variant="cartRegular">
          ₹
          {IsDoctor()
            ? parseFloat(doctorPrice).toFixed(2)
            : parseFloat(price).toFixed(2)}
        </Text>
      </Box>
      <Box width="23%">
        <Quantity id={id} quantity={quantity} />
      </Box>

      <Box width="20%">
        <Flex justifyContent="space-between" align="center" alignItems="center">
          <Text variant="cartRegular">₹{productSubTotal.toFixed(2)}</Text>
          <Delete
            height="25"
            width="25"
            color="#49586B"
            onClick={() => dispatch(removeFromCart(id))}
          />
        </Flex>
      </Box>
    </Flex>
  );
}
